import { OwaDate, differenceInDays, now, startOfDay } from 'owa-datetime';

export default function(dueDate: OwaDate, referenceDate: OwaDate = now()): boolean {
    if (differenceInDays(startOfDay(referenceDate), startOfDay(dueDate)) > 0) {
        return true;
    }

    return false;
}
